import { useMemo } from "react"
import { useIntl } from "react-intl"

import { Button, Dialog, ICONS, StaffHeading3 } from "@doktor-se/bones-ui"
import { AssignedConversation } from "@doktor-se/bones-ui/dist/web-shared/types"

import { BookedAppointment } from "reducers/conversations/conversations.reducer"

import { QueueConversation } from "../../../../../types"

import styles from "./ConfirmDialog.module.scss"

export interface ConfirmDialogProps {
  isOpen: boolean
  offset?: { top?: string; right?: string; bottom?: string; left?: string }
  message: string
  title: string
  conversation?: QueueConversation | AssignedConversation | BookedAppointment
  onClose: () => void
  onCancel?: () => void
  onConfirm: () => void
  confirmText: string
  cancelText?: string
}

const ConfirmDialog = ({
  isOpen,
  offset,
  title,
  message,
  conversation,
  onClose,
  onCancel,
  onConfirm,
  confirmText,
  cancelText
}: ConfirmDialogProps) => {
  const intl = useIntl()

  const patientDetails = useMemo(() => {
    if (conversation) {
      const isChildConversation = !!conversation?.profile
      if (isChildConversation) {
        return (
          <>
            <div className={styles.displayName}>{conversation.profile?.name}</div>
            <div className={styles.pnr}>{conversation.profile?.data?.securityNumber}</div>
          </>
        )
      }

      return (
        <>
          <div className={styles.displayName}>{conversation.account.displayName}</div>
          <div className={styles.pnr}>{conversation.account.pnr}</div>
        </>
      )
    }
    return <></>
  }, [conversation])

  return (
    <Dialog
      isOpen={isOpen}
      offset={offset}
      onClose={onClose}
      closeAriaLabel={intl.formatMessage({ id: "modal.close" })}
      fixedWidth>
      <ICONS.WarningCircle width={40} height={40} />
      <StaffHeading3 margin={{ bottom: "var(--size-200)" }} className={styles.header}>
        {title}
      </StaffHeading3>
      {patientDetails}

      <div className={styles.contentContainer}>{message}</div>
      <div className={styles.buttonContainer}>
        <Button color="primary" variant="primary" onPress={onConfirm} fullWidth>
          {confirmText}
        </Button>
      </div>
      {onCancel && (
        <div className={styles.buttonContainer}>
          <Button color="primary" variant="outline" onPress={onCancel} fullWidth>
            {cancelText}
          </Button>
        </div>
      )}
    </Dialog>
  )
}

export default ConfirmDialog
